import { Box } from '@mui/material';
import { drawerWidth, SideDrawer } from '../components/SideDrawer';
import { MessageAction } from '../components/MessageAction';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import React from 'react';

export enum RootComponents {
  Home,
  Goals,
  Reports,
  Schedule,
  Parent_Led_Curriculum,
  Dimension_Parent_Class,
  Chat_Curriculum,
  Articles,
  Events,
  Community,
  Saved,
  Session_Feedback,
  ProgressPortrait,
}
export const getRootComponentPath = (component: RootComponents): string =>
  RootComponents[component].toLowerCase().replaceAll('_', '-');

export const RootPage = (props: { children: React.ReactNode }) => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: '#f7f8fb',
          display: 'flex',
        }}
      >
        <SideDrawer />
        <Box
          component='main'
          sx={{
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
            width: { sm: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          {props.children}
          <MessageAction />
        </Box>
      </Box>
      <ToastContainer
        position='bottom-left'
        autoClose={3000}
        hideProgressBar
        newestOnTop
        closeOnClick
        rtl={false}
        draggable
        pauseOnHover
      />
    </>
  );
};
